import React from 'react';
import EditableField from './EditableField';
import Tooltip from './Tooltip';
import './Stats.css'; // Reuse stats styling

const CombatStats = ({ armorClass, initiative, speed, updateCharacter }) => {
    return (
        <div className="combat-stats-column">
            <div className="stat-block">
                <label>
                    Armor Class
                    <Tooltip text="How hard it is to hit you. 10 + Dex Modifier.">
                        <span className="help-icon">?</span>
                    </Tooltip>
                </label>
                <div className="value">{armorClass}</div>
            </div>
            <div className="stat-block">
                <label>
                    Initiative
                    <Tooltip text="Determines order in combat. Dex Modifier + Bonuses.">
                        <span className="help-icon">?</span>
                    </Tooltip>
                </label>
                <div className="value">{initiative >= 0 ? '+' : ''}{initiative}</div>
            </div>
            <div className="stat-block">
                <label>Speed</label>
                <div className="value">
                    <EditableField path={['speed']} value={speed} updateCharacter={updateCharacter} />
                </div>
            </div>
        </div>
    );
};

export default CombatStats;
